import type { NotificationState } from '@/hooks/useNotification';
import { Alert, Snackbar } from '@mui/material';
import React from 'react';

interface NotificationProps {
  notification: NotificationState;
  onClose: () => void;
  autoHideDuration?: number;
}

export const Notification: React.FC<NotificationProps> = ({
  notification,
  onClose,
  autoHideDuration = 6000,
}) => {
  return (
    <Snackbar
      open={notification.open}
      autoHideDuration={autoHideDuration}
      onClose={onClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
    >
      <Alert
        onClose={onClose}
        severity={notification.severity}
        sx={{ width: '100%', whiteSpace: 'pre-line' }}
      >
        {notification.message}
      </Alert>
    </Snackbar>
  );
};
